import React, {useState} from 'react'
import { HeroContainer, HeroBg, Logo, HeroContent, HeroH1, HeroP, HeroBtnWrapper } from './HeroElements'
import { Button } from '../ButtonElements'
import LogoImage from '../../images/ATENIDA-2-NOWE-7.png'
import { animateScroll as scroll } from 'react-scroll';


const HeroSection = () => {
const toggleHome = () => {
  scroll.scrollTo(20, { smooth: true, duration: 600 });
};
    
    const [hover, setHover] = useState(false)

    const onHover = () => {
        setHover(!hover)
    }


  return (
    <>
        <HeroContainer id='home'>
            <HeroBg>
            </HeroBg>
            <HeroContent>
                <Logo src={LogoImage} />
                <HeroH1>Tworzę ceremonie, w których czułe przeżywanie straty spotyka się<br></br> z pamięcią o życiu.</HeroH1>
                <HeroP>
                Projektuję pożegnania celebrujące życie - dla osób, które chcą pożegnać bliskiego<br></br> w sposób osobisty, pełen sensu i piękna, tak aby ten dzień stał się wspierającym<br></br> rytuałem, a nie tylko bolesnym obowiązkiem.
                </HeroP>
                <HeroBtnWrapper>
                    <Button to="/kontakt" onClick={toggleHome} onMouseEnter={onHover} onMouseLeave={onHover} primary='true' dark='true' big='true'>
                    Umów rozmowę
                    </Button>
                    <Button to="/pakiety" onClick={toggleHome} onMouseEnter={onHover} onMouseLeave={onHover} primary='true' dark='true' big='true'>
                    Zobacz pakiety
                    </Button>
                </HeroBtnWrapper>
            </HeroContent>
        </HeroContainer>
    </>
  )
}

export default HeroSection